import { defineMessages } from "@formatjs/intl";

const PREFIX = "lms.guide03.challenges-slide";
export const messages = defineMessages({
  challengesDescription: {
    id: `${PREFIX}.description`,
  },
  challengesDescription2: {
    id: `${PREFIX}.description2`,
  },
  challengesDescription3: {
    id: `${PREFIX}.description3`,
  },
  challengesTitle2: {
    id: `${PREFIX}.title2`,
  },
  challengesTitle3: {
    id: `${PREFIX}.title3`,
  },
  challengesTitle1: {
    id: `${PREFIX}.title1`,
  },
  title: {
    id: `${PREFIX}.title`,
  },
});
